
export default (Vue) => {
  Vue.component('countdown', () => import('./countdown/countdown'))
  Vue.component('modal', () => import('./modal/modal'))
  Vue.component('mbvodal', () => import('./mbvodal/mbvodal'))
  Vue.component('maps', () => import('./maps/map.vue'))
  Vue.component('card-add', () => import('./card-add'))
  Vue.component('page', () => import('./page/page'))
  Vue.component('page-search-bar', () => import('./page/page-search-bar'))
  Vue.component('pagefull', () => import('./pagefull'))
  Vue.component('pagination', () => import('./pagination/pagination'))
  // Vue.component('medibook-select', () => import('./select/select'))
  Vue.component('medibook-select', () => import('./select/select_new'))
  Vue.component('professional-select', () => import('./select/select_professional'))

  // Vue.component('professional-select', () => import('./select/select'))
  Vue.component('spinner', () => import('./spinner'))
  Vue.component('spinner-professional', () => import('./spinner-professsional'))
  Vue.component('card-step', () => import('./card-step'))
  Vue.component('medibook-alert', () => import('./medibook/alert'))
  Vue.component('medibook-delete', () => import('./medibook/delete'))
  Vue.component('medibook-success', () => import('./medibook/success'))
  Vue.component('medibook-alert-error', () => import('./medibook/error'))
  Vue.component('medibook-included', () => import('./medibook/included'))
  Vue.component('medibook-alert-custom', () => import('./medibook/custom'))
  Vue.component('medibook-alert-custom-slot', () => import('./medibook/custom-slot'))
  Vue.component('v-input', () => import('./veulidate/v-input/v-input'))
  Vue.component('v-input-same-password', () => import('./veulidate/v-input-same-password/v-input'))
  Vue.component('v-input-country-register', () => import('./veulidate/v-input-country-register/v-input'))
  Vue.component('professional-documents-score', () => import('./documents-badge/score/score'))
  Vue.component('terms', () => import('./terms'))
}



// WEBPACK FOOTER //
// ./src/components/root/index.js